import React, { useState } from 'react'
import { LAYOUT_DATA_URL } from '../api/settings'
import LoadingMessages from '../components/_common/LoadingMessages'
import HeaderUser from './HeaderUser'
import LangSwitch from './LangSwitch'
import { useLayoutData } from './useLayoutData'

const Header = ({ langSwith = false }: { langSwith?: boolean }) => {
  const [isActive, setIsActive] = useState(false)

  const layoutData = useLayoutData()
  if (!layoutData) {
    return <LoadingMessages/>
  }
  const { headerMenu: dataHeaderMenu } = layoutData

  const handleToggle = () => {
    setIsActive(!isActive)
  }

  return (
    <header className="sukl-header">
      <div className="header-inner">
        <div className="header-holder">
          <div className="header-left">
            <a href={LAYOUT_DATA_URL} aria-label="SÚKL">
              <img alt="SÚKL - logo" className="sukl-logo" src="/sukl-white.svg" width="134" height="36"/>
              <span className="sukl-logo-name">STÁTNÍ ÚSTAV <br/>PRO KONTROLU LÉČIV</span>
            </a>
            <div className="header-lang mobile noprint">
              {langSwith && <LangSwitch/>}
            </div>
          </div>

          <div className="header-right noprint">
            <div className="gov-search">
              <form className="gov-search__inner" action={'https://sukl.gov.cz/vyhledavani'}>
                <input name="term" placeholder="Vyhledávání na webu…" type="text"
                       className="gov-form-control__input"
                       role="searchbox"
                       aria-label="Vyhledávání na webu…"
                />
                <button className="gov-search__submit desktop" type="submit">
                  <i className="fas fa-search"></i>
                </button>
              </form>
            </div>

            <a href="https://sukl.gov.cz/vyhledavani" className="gov-search__submit mobile">
              <i className="fas fa-search"></i>
            </a>

            <HeaderUser/>

            <button className={`gov-header__hamburger ${isActive ? 'active' : ''}`} onClick={handleToggle}>
              <span></span>
              <span></span>
              <div>MENU</div>
            </button>

            <div className="header-lang">
              {langSwith && <LangSwitch/>}
            </div>
          </div>
        </div>

        <nav className="desktop noprint">
          <div className="nav-holder">
            {dataHeaderMenu.map((item, index) => (
              <a key={index} className="navlink" href={item.path}>
                {item.text}
              </a>
            ))}
          </div>
        </nav>

        <div className={`gov-header__overlay ${isActive ? 'active' : ''}`}></div>

        <nav className={`mobile noprint ${isActive ? 'active' : ''}`}>
          <div className="nav-holder">
            {dataHeaderMenu.map((item, index) => (
              <a key={index} className="navlink" href={item.path}>
                {item.text}
              </a>
            ))}
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header
